module.exports = __webpack_public_path__ + "img/jo.c88aedbb.svg";